// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__22fVB","title":"Images90_title__2jome","images":"Images90_images__U9Iuy"};